import { useL10n } from '^/hooks';
import theme from '^/theme';
import React from 'react';
import styled from 'styled-components';
import Text from './text';
import InfoCircleSvg from '^/assets/icons/photo-request/info-circle.svg';

const MIN_DAYS = 2;
const MAX_WEEKS = 2;

const NotificationBox = styled.div({
  padding: '12px',
  backgroundColor: theme.colors.neutralBlue[50],
  borderRadius: '8px',
  display: 'flex',
  gap: '11px',
  marginInline: '20px',
  marginTop: '14px',
});

const TextContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
});

const NotificationTitle = styled.div({
  fontWeight: '600',
  lineHeight: '20px',
  color: theme.colorTokens.textCoolDarker,
});

const NotificationText = styled.div({
  color: theme.colors.neutralGray[700],
  fontSize: '12px',
  lineHeight: '150%',
});

const SvgContainer = styled.div({
  height: '14px',
  width: '14px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export function RequestedInfo() {
  const [l10n] = useL10n();
  return (
    <NotificationBox>
      <SvgContainer>
        <InfoCircleSvg />
      </SvgContainer>
      <TextContainer>
        <NotificationTitle>{l10n(Text.successfullyRequested)}</NotificationTitle>
        <NotificationText>{l10n(Text.minMaxDays(MIN_DAYS, MAX_WEEKS))}</NotificationText>
      </TextContainer>
    </NotificationBox>
  );
}
